(() => {
 if(window.prSupportReady)return;window.prSupportReady=true;
 const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
 const selector='.lr details, .pr-home-menu, .pr-mobile-menu, .pr-chat details, .pr-faq details, .pr-shared-faq details';
 const animations=new WeakMap();
 const targets=new WeakMap();
 const setDisclosure=(details,opening)=>{
  const content=[...details.children].find(e=>e.tagName!=='SUMMARY');if(!content){details.open=opening;return;}
  const startHeight=details.getBoundingClientRect().height;
  const previous=animations.get(details);if(previous){previous.onfinish=null;previous.cancel();}
  targets.set(details,opening);
  details.removeAttribute('name');
  if(opening && box()?.open) close(false);
  if(opening)document.querySelectorAll(selector).forEach(other=>{if(other!==details&&other.open&&!other.contains(details))setDisclosure(other,false);});
  if(!details.open&&!opening)return;
  details.open=true;
  if(reduced()){details.open=opening;details.style.overflow='';animations.delete(details);return;}
  // Animate the complete accordion box, including answer padding, so its
  // neighbours move continuously and an interrupted toggle never jumps.
  if(details.matches('.lr details, .pr-faq details, .pr-shared-faq details')){
   const summary=details.querySelector('summary'),style=getComputedStyle(details);
   const border=parseFloat(style.borderTopWidth)+parseFloat(style.borderBottomWidth);
   const endHeight=opening?details.getBoundingClientRect().height:summary.getBoundingClientRect().height+border+parseFloat(style.paddingTop)+parseFloat(style.paddingBottom);
   details.style.overflow='hidden';
   const animation=details.animate([{height:startHeight+'px'},{height:endHeight+'px'}],{duration:360,easing:'cubic-bezier(.22,1,.36,1)'});
   animations.set(details,animation);
   animation.onfinish=()=>{details.open=opening;details.style.overflow='';animations.delete(details);targets.delete(details);};
   return;
  }
  const height=content.scrollHeight;
  const animation=content.animate(opening?[{height:'0px',opacity:0,transform:'translateY(-5px)'},{height:height+'px',opacity:1,transform:'translateY(0)'}]:[{height:height+'px',opacity:1,transform:'translateY(0)'},{height:'0px',opacity:0,transform:'translateY(-5px)'}],{duration:220,easing:'cubic-bezier(.2,.7,.3,1)'});
  content.style.overflow='hidden';
  animations.set(details,animation);
  animation.onfinish=()=>{details.open=opening;content.style.overflow='';animations.delete(details);};
 };
 window.prSetDisclosure=setDisclosure;
 let trigger,chatAnimation;
 const box=()=>document.getElementById('pr-support-chat');
 const faqDialog=()=>document.getElementById('pr-faq-dialog');
 let faqTrigger,faqAnimation;
 const closeFaq=(restoreFocus=true)=>{
  const dialog=faqDialog();if(!dialog?.open)return;
  faqAnimation?.cancel();
  const finish=()=>{dialog.close();if(restoreFocus)faqTrigger?.focus({preventScroll:true});};
  if(reduced()){finish();return;}
  faqAnimation=dialog.animate([{opacity:1,transform:'translateY(0) scale(1)'},{opacity:0,transform:'translateY(14px) scale(.98)'}],{duration:210,easing:'cubic-bezier(.4,0,1,1)'});
  faqAnimation.onfinish=finish;
 };
 const openFaq=button=>{
  const dialog=faqDialog();if(!dialog)return;
  if(dialog.open)return;
  faqTrigger=button;
  document.querySelectorAll('.pr-mobile-menu[open], .pr-home-menu[open]').forEach(menu=>setDisclosure(menu,false));
  if(box()?.open)close(false);
  dialog.showModal();
  dialog.querySelector('[data-pr-faq-close]')?.focus({preventScroll:true});
  if(!reduced())dialog.animate([{opacity:0,transform:'translateY(18px) scale(.97)'},{opacity:1,transform:'translateY(0) scale(1)'}],{duration:310,easing:'cubic-bezier(.22,1,.36,1)'});
 };
 faqDialog()?.addEventListener('cancel',event=>{event.preventDefault();closeFaq();});
 faqDialog()?.addEventListener('click',event=>{if(event.target===faqDialog())closeFaq();});
 const open=()=>{
  const d=box();if(!d)return;
  document.querySelectorAll(selector).forEach(el=>{if(el.open)setDisclosure(el,false);});
  if(d.open)return;
  chatAnimation?.cancel();d.show(); // Non-modal: no backdrop, focus trap, or document scroll lock.
  d.querySelector('#pr-chat-question')?.focus({preventScroll:true});
 };
 const close=(restoreFocus=true)=>{
  const d=box();if(!d?.open)return;
  if(reduced()){d.close();if(restoreFocus)trigger?.focus({preventScroll:true});return;}
  chatAnimation=d.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(10px)'}],{duration:180,easing:'ease-out'});
  chatAnimation.onfinish=()=>{d.close();if(restoreFocus)trigger?.focus({preventScroll:true});};
 };
 const answers={
  fit:{label:'Size & fit',patterns:[/siz(e|es|ing)/,/fit(s|ting)?/,/waist/,/too (big|small|tight|loose)/,/clothes|clothing|shirt/],text:'LumbarRelief™ has adjustable fastening and support straps. Position it around your lower back and waist, fasten the main closure, then adjust both straps evenly. It should feel snug while still letting you breathe and move comfortably. A thin T-shirt underneath is fine.'},
  battery:{label:'Battery & charging',patterns:[/batter(y|ies)/,/charg(e|es|ed|ing|er)/,/recharg/,/usb/,/power/,/cable/],text:'LumbarRelief™ includes a detachable battery/controller and USB-C charging cable. Follow the supplied charging instructions before use.'},
  settings:{label:'Heat & vibration',patterns:[/heat|warm|temperature/,/vibrat|massage/,/setting|level|mode/,/compress/],text:'LumbarRelief™ combines adjustable support and heat with 3 vibration modes. You can also wear it as a support belt with the electronic features switched off. Adjust the straps for a comfortable fit.'},
  included:{label:"What's included?",patterns:[/includ|come with|in the box|package contain/,/sachet|mugwort/,/manual|accessor/],text:'The package includes the LumbarRelief™ belt, detachable battery/controller, USB-C charging cable, instruction guide, and the warming sachets/accessories shown on the product page.'},
  returns:{label:'Trial & returns',patterns:[/return|refund/,/trial|guarantee|risk.free/,/cancel/],text:'There is a 30-day trial from delivery. If it is not right for you, contact support within 30 days and the team will guide you through the return process. Approved refunds go back to the original payment method.'},
  shipping:{label:'Shipping & orders',patterns:[/ship|deliver|parcel|postage/,/track|order status|where.*order|arriv/,/how long|when.*get/],text:'Standard shipping is free and generally takes 6–14 days after dispatch. Priority Shipping moves your order forward in the processing queue; carrier transit time may vary. Tracking is sent after dispatch. I cannot access individual orders; use Ask support for order help.'},
  use:{label:'Using the brace',patterns:[/how.*(use|wear|put on)/,/wear|driv|sit|work|session|often/],text:'Place the wrap around your lower back, fasten the main closure, then adjust both support straps evenly. Follow the included guide for session length and controls.'},
  care:{label:'Cleaning & care',patterns:[/clean|wash|care|water|wet/],text:'Switch off the brace and disconnect it from charging before cleaning. Follow the supplied care guide, and do not immerse the battery/controller in water.'}
 };
 const logMessage=(text,type)=>{
  const log=box().querySelector('.pr-chat-log'),p=document.createElement('p');p.className='pr-chat-bubble pr-chat-bubble--'+type;p.textContent=text;log.append(p);
  while(log.children.length>20)log.firstElementChild.remove();
 };
 let lastQuestion='',pending=false;
 const privateInput=value=>/\b[\w.+-]+@[\w.-]+\.[a-z]{2,}\b/i.test(value)||/(?:\d[\s-]?){10,}/.test(value)||/\b(password|passcode|cvv|cvc|security code|card number|credit card|bank account|street address)\b/i.test(value);
 const codeInput=value=>/<\/?[a-z][^>]*>|javascript:|data:text\/html|<\?|\?>|```|\b(?:eval|document\.cookie|localStorage|fetch\s*\(|SELECT\s+.+\s+FROM)\b/i.test(value);
 const matchAnswer=question=>{
  const normalized=question.toLowerCase().replace(/[^a-z0-9\s]/g,' ');
  const ranked=Object.entries(answers).map(([id,item])=>({id,score:item.patterns.reduce((score,pattern)=>score+(pattern.test(normalized)?1:0),0)})).sort((a,b)=>b.score-a.score);
  return ranked[0]?.score?ranked[0].id:null;
 };
 const scrollChat=d=>{const body=d.querySelector('.pr-chat-body');body.scrollTo({top:body.scrollHeight,behavior:reduced()?'instant':'smooth'});};
 const answer=(question,key)=>{
  const d=box();if(!d||pending)return;
  const unsafe=privateInput(question)||codeInput(question);
  lastQuestion=unsafe?'':question;
  logMessage(unsafe?'[Message withheld for privacy and safety]':question,'user');
  pending=true;
  const indicator=document.createElement('p');indicator.className='pr-chat-bubble pr-chat-bubble--bot pr-chat-typing';indicator.setAttribute('role','status');indicator.setAttribute('aria-label','Physio Relief is typing');
  indicator.innerHTML='<span aria-hidden="true">●</span><span aria-hidden="true">●</span><span aria-hidden="true">●</span>';
  d.querySelector('.pr-chat-log').append(indicator);scrollChat(d);
  window.setTimeout(()=>{
   indicator.remove();
   const selected=key||(!unsafe&&matchAnswer(question));
   const reply=unsafe?'Please do not enter code, card details, passwords, contact details or other private information here. This chat only answers general questions. Choose Ask support for order-specific help.':selected?answers[selected].text:"I don't have a reliable answer for that question yet. Choose a topic below, or Ask support and our team can help.";
   logMessage(reply,'bot');pending=false;
   d.querySelector('.pr-chat-followup').hidden=false;scrollChat(d);
  },reduced()?250:750);
 };
 document.addEventListener('submit',event=>{
  if(!event.target.matches('.pr-chat-compose'))return;
  event.preventDefault();const input=event.target.querySelector('input'),question=input.value.trim();if(!question)return;input.value='';answer(question);
 });
 document.addEventListener('click',event=>{
  const target=event.target instanceof Element?event.target:null;if(!target)return;
  const summary=target.closest('summary');
  if(summary&&summary.parentElement.matches(selector)){
   event.preventDefault();const details=summary.parentElement;setDisclosure(details,!(targets.get(details)??details.open));return;
  }
  const button=target.closest('[data-pr-chat-open]');
  const faqButton=target.closest('[data-pr-faq-open]');if(faqButton)openFaq(faqButton);
  if(target.closest('[data-pr-faq-close]'))closeFaq();
  if(button){trigger=button;open();}
  if(target.closest('[data-pr-chat-close]'))close();
  const topic=target.closest('[data-pr-topic]');if(topic)answer(answers[topic.dataset.prTopic].label,topic.dataset.prTopic);
  if(target.closest('[data-pr-another]')){
   box().querySelector('#pr-chat-contact').hidden=true;
   box().querySelector('#pr-chat-question').focus({preventScroll:true});
   box().querySelector('.pr-chat-topics').scrollIntoView({block:'nearest',behavior:reduced()?'instant':'smooth'});
  }
  if(target.closest('[data-pr-escalate]')){
   const contact=document.getElementById('pr-chat-contact');contact.hidden=false;
   const message=contact.querySelector('textarea');if(message&&!message.value)message.value=lastQuestion;
   contact.scrollIntoView({behavior:reduced()?'instant':'smooth',block:'nearest'});
   contact.querySelector('input:not([type=hidden])')?.focus({preventScroll:true});
  }
  document.querySelectorAll('.pr-home-menu[open]').forEach(menu=>{if(!menu.contains(target))setDisclosure(menu,false);});
 });
 document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  document.querySelectorAll(selector).forEach(el=>{if(el.open)setDisclosure(el,false);});
  if(box()?.contains(document.activeElement))close();
 });
 const result=document.querySelector('[data-pr-contact-result]');
 if(result){document.getElementById('pr-chat-contact').hidden=false;open();result.scrollIntoView();}
})();
